/**
 * @generated SignedSource<<30011c2473182d64abb23914a7830230>>
 * @relayHash 3d666e4550087a85d1fd03eff6d75db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID debceaeb7e53a1b935780cd30c900627efd1b1f17abdf65b4458c6256adba0a2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiOnboardingGetStartedPageQuery$variables = {
  cloudId: string;
  siteAri: string;
};
export type uiOnboardingGetStartedPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CodeSection_codeIntegrationData">;
};
export type uiOnboardingGetStartedPageQuery = {
  response: uiOnboardingGetStartedPageQuery$data;
  variables: uiOnboardingGetStartedPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "concreteType": "JiraConfigStateConnection",
    "kind": "LinkedField",
    "name": "config",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraConfigState",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "appId"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          }
        ]
      }
    ]
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiOnboardingGetStartedPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "CodeSection_codeIntegrationData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiOnboardingGetStartedPageQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "siteAri"
              },
              {
                "kind": "Literal",
                "name": "providerTypes",
                "value": [
                  "DEV_INFO"
                ]
              }
            ],
            "concreteType": "DevOpsProviders",
            "kind": "LinkedField",
            "name": "providers",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsDevInfoProvider",
                "kind": "LinkedField",
                "name": "devInfoProviders",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraAppConfigState",
                    "kind": "LinkedField",
                    "name": "configState",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "appId",
                    "value": "bitbucket"
                  },
                  (v3/*: any*/)
                ],
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": (v6/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "concreteType": "CodeInJiraUserConfiguration",
            "kind": "LinkedField",
            "name": "userConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "CodeInJiraBitbucketWorkspace",
                "kind": "LinkedField",
                "name": "ownedBitbucketWorkspaces",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "debceaeb7e53a1b935780cd30c900627efd1b1f17abdf65b4458c6256adba0a2",
    "metadata": {},
    "name": "uiOnboardingGetStartedPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b249f917d1cb2119715301e4ae9e0d44";

export default node;
